import React from "react";
import { NavLink } from "react-router-dom";
import { ListGroup, ListGroupItem } from 'reactstrap';

import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

import MyDateRenderer from "./MyDateRenderer";
import ConfirmModal from "./ConfirmModal";
import CustomerCategoryLabel from "./CustomerCategoryLabel";

import { useDispatch, useSelector } from "react-redux";
import * as isoDashboardActions from "../actions/IsoDashboardActions";

const IsoDashboardList = (props) => {
    const dispatch = useDispatch();

    const user = useSelector((state) => state.login.user);

    const certificationAdminUserList = useSelector((state) => state.isodashboard.certificationAdminUserList);
    const sacMdcIssuerUserList = useSelector((state) => state.isodashboard.sacMdcIssuerUserList);
    const nonSacMdcIssuerUserList = useSelector((state) => state.isodashboard.NonSacMdcIssuerUserList);
    const schedulingResponsibleUserList = useSelector((state) => state.isodashboard.schedulingResponsibleUserList);
    const auditDocumentReviewerUserList = useSelector((state) => state.isodashboard.auditDocumentReviewerUserList);
    const technicalReviewerUserList = useSelector((state) => state.isodashboard.technicalReviewerUserList);
    const decisionMakerUserList = useSelector((state) => state.isodashboard.decisionMakerUserList);

    const [selectedId, setSelectedId] = React.useState(0);
    const [selectedIndex, setSelectedIndex] = React.useState(-1);
    const [selectedUserId, setSelectedUserId] = React.useState(-1);
    const [showAssignMeModal, setShowAssignMeModal] = React.useState(false);
    const [showAssignModal, setShowAssignModal] = React.useState(false);

    const getInvoiceNumberDisplay = (item) => {
        var value = "";

        if(item.companyName && item.companyName.length > 0) {
            if(value.length > 0) {
                value += " | ";
            }
            
            if(item.companyName === "Europe") {
                value += "EU";
            }
            else if(item.companyName === "Saudi Arabia") {
                value += "KSA";
            }
        }
        
        if(item.crmInvoiceNumber && item.crmInvoiceNumber.length > 0) {
            if(value.length > 0) {
                value += " | ";
            }
            
            value += item.crmInvoiceNumber;
        }

        if(item.taxInvoiceNumber && item.taxInvoiceNumber.length > 0) {
            if(value.length > 0) {
                value += " | ";
            }
            
            value += item.taxInvoiceNumber;
        }

        if(item.referenceNumber && item.referenceNumber.length > 0) {
            if(value.length > 0) {
                value += " | ";
            }
            
            value += item.referenceNumber;
        }

        return value;
    }

    const onCloseModalClick = () => {
        setSelectedId(0);
        setSelectedIndex(-1);
        setSelectedUserId(-1);
        setShowAssignMeModal(false);
        setShowAssignModal(false);
    }

    const assignMeTicket = (id, index) => {
        setSelectedId(id);
        setSelectedIndex(index);
        setSelectedUserId(user.id);
        setShowAssignMeModal(true);
    }

    const onAssignMeTicket = async () => {
        if(selectedId > 0 && selectedIndex >= 0 && selectedUserId > 0) {
            dispatch(isoDashboardActions.assignIsoRequest(selectedId, selectedUserId, true, props.list, selectedIndex));
        }

        onCloseModalClick();
    }

    const assignTicket = (id, index, userId) => {
        setSelectedId(id);
        setSelectedIndex(index);
        setSelectedUserId(userId);
        setShowAssignModal(true);
    }

    const onAssignTicket = async () => {
        if(selectedId > 0 && selectedIndex >= 0 && selectedUserId > 0) {
            dispatch(isoDashboardActions.assignIsoRequest(selectedId, selectedUserId, false, props.list, selectedIndex));
        }

        onCloseModalClick();
    }

    return (
        <div className="tasks-list">
            <div className="d-flex mb-2">
                <div className="flex-grow-1">
                    <h6 className="fs-14 text-uppercase fw-semibold mb-0">{props.title} <small className={`badge ${props.titleClass} align-bottom ms-1 totaltask-badge`}>{props.list ? props.list.length : 0}</small></h6>
                </div>
            </div>
            <SimpleBar className="tasks-wrapper px-3 mx-n3" forceVisible={true} autoHide={false}>
                <div className="tasks">
                    {props.list && props.list.map(function(item, index){
                        return(
                            <div key={index} className={`card tasks-box ${item.ticketType === "CONTAINER" ? ["card-light", "border", "border-1", props.borderClass].join(" ") : ""}`} key={index}>
                                <div className="card-body">
                                    <div className="d-flex">
                                        <h6 className="fs-15 mb-0 flex-grow-1 text-truncate task-title">
                                            <NavLink to={`/iso-request-edit/${item.id}`} className="text-body d-block">{item.requestNumber}</NavLink>
                                        </h6>
                                    </div>
                                    {item.customerName &&
                                    <p className="mb-0 fs-11 flex-grow-1 text-truncate text-dark" style={{marginBottom:0}}>
                                        {item.customerName}
                                        <CustomerCategoryLabel value={item.customerCategory || ""} />
                                    </p>
                                    }
                                    <p className="fs-11 flex-grow-1 text-truncate text-muted">
                                        {getInvoiceNumberDisplay(item)}
                                    </p>
                                    <div className="align-items-center">
                                        <div>
                                            {item.requestTypeName?.split(",").map((name, index) => (
                                                <div key={index}>
                                                    <span className="badge bg-success">
                                                        {name.trim()}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="pt-1" style={{textAlign:"right"}}>
                                            <div>
                                                {props.title === "New" && user && user.isIsoCertificationAdmin && !user.isIsoManager && !user.isIsoOperationManager && !item.certificationAdminUserName &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }                                                
                                                {props.title === "Document Review" && user && user.isIsoAuditDocumentReviewer && !user.isIsoManager && !user.isIsoOperationManager && !item.auditDocumentReviewerUserName &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }
                                                {props.title === "Technical Review" && user && user.isIsoTechnicalReviewer && !user.isIsoManager && !user.isIsoOperationManager && !item.technicalReviewerUserId &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }
                                                {props.title === "Decision Making" && user && user.isIsoDecisionMaker && !user.isIsoManager && !user.isIsoOperationManager && !item.decisionMakerUserName &&
                                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Assign Me"
                                                        onClick={() => assignMeTicket(item.id, index)}
                                                    >
                                                        <i className="ri-user-follow-line" />
                                                    </button>
                                                }
                                                {props.title === "New" && user && (user.isIsoManager || user.isIsoOperationManager) && !item.certificationAdminUserName &&
                                                    <select className="form-select-sm"
                                                        value={index === selectedIndex ? selectedUserId : ""}
                                                        onChange={e => assignTicket(item.id, index, e.target.value)}
                                                    >
                                                        <option value={0}>...</option>
                                                        {certificationAdminUserList && certificationAdminUserList.map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.id}>{item.fullName}</option>
                                                            );
                                                        })}
                                                    </select>
                                                }
                                                {props.title === "Document Review" && user && (user.isIsoManager || user.isIsoOperationManager) && !item.auditDocumentReviewerUserName &&
                                                    <select className="form-select-sm"
                                                        value={index === selectedIndex ? selectedUserId : ""}
                                                        onChange={e => assignTicket(item.id, index, e.target.value)}
                                                    >
                                                        <option value={0}>...</option>
                                                        {auditDocumentReviewerUserList && auditDocumentReviewerUserList.map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.id}>{item.fullName}</option>
                                                            );
                                                        })}
                                                    </select>
                                                }
                                                {props.title === "Technical Review" && user && (user.isIsoManager || user.isIsoOperationManager) && !item.technicalReviewerUserName &&
                                                    <select className="form-select-sm"
                                                        value={index === selectedIndex ? selectedUserId : ""}
                                                        onChange={e => assignTicket(item.id, index, e.target.value)}
                                                    >
                                                        <option value={0}>...</option>
                                                        {technicalReviewerUserList && technicalReviewerUserList.map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.id}>{item.fullName}</option>
                                                            );
                                                        })}
                                                    </select>
                                                }
                                                {props.title === "Decision Making" && user && (user.isIsoManager || user.isIsoOperationManager) && !item.decisionMakerUserName &&
                                                    <select className="form-select-sm"
                                                        value={index === selectedIndex ? selectedUserId : ""}
                                                        onChange={e => assignTicket(item.id, index, e.target.value)}
                                                    >
                                                        <option value={0}>...</option>
                                                        {decisionMakerUserList && decisionMakerUserList.map(function(item, index){
                                                            return (
                                                                <option key={index} value={item.id}>{item.fullName}</option>
                                                            );
                                                        })}
                                                    </select>
                                                }
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.certificationAdminUserName}</span>
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.schedulingResponsibleUserName}</span>
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.mdcIssuerUserName}</span>
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.caseLeaderUserName}</span>
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.auditDocumentReviewerUserName}</span>
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.technicalReviewerUserName}</span>
                                            </div>
                                            <div>
                                                <span className="badge bg-success">{item.decisionMakerUserName}</span>
                                            </div>
                                            {item.auditUserName?.split("/").map((name, index) => (
                                                <div key={index}>
                                                    <span className="badge bg-secondary">
                                                        {name.trim()}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    {item.ticketType === "CONTAINER" && 
                                    <div className="mt-3">
                                        <ListGroup>
                                            {item.draftCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Draft <span className="badge bg-success">{item.draftCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.newCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                New <span className="badge bg-success">{item.newCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.salesActionCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Sales Action <span className="badge bg-success">{item.salesActionCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.calculateManDaysCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Calculate Man Days <span className="badge bg-success">{item.calculateManDaysCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.schedulingCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Scheduling <span className="badge bg-success">{item.schedulingCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.auditInProgressCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Audit In Progress <span className="badge bg-success">{item.auditInProgressCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.documentReviewCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Document Review <span className="badge bg-success">{item.documentReviewCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.technicalReviewCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Technical Review <span className="badge bg-success">{item.technicalReviewCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.decisionMakingCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Decision Making <span className="badge bg-success">{item.decisionMakingCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.completedCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Completed <span className="badge bg-success">{item.completedCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.closedCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Closed <span className="badge bg-success">{item.closedCount}</span>
                                            </ListGroupItem>
                                            }
                                            {item.abortedCount > 0 &&
                                            <ListGroupItem className="d-flex justify-content-between align-items-center">
                                                Aborted <span className="badge bg-success">{item.abortedCount}</span>
                                            </ListGroupItem>
                                            }
                                        </ListGroup>
                                    </div>
                                    }
                                </div>
                                <div className="card-footer border-top-dashed" style={{paddingTop:5, paddingBottom:5}}>
                                    <div className="d-flex">
                                        <div className="flex-grow-1">
                                            <ul className="link-inline mb-0" style={{paddingLeft:0}}>
                                                <li className="list-inline-item">
                                                    <i className="ri-user-add-line align-bottom"></i> {item.addedBy} | <MyDateRenderer value={item.dateAdded} format="mm/dd/yy" />
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="flex-shrink-0">
                                            <ul className="link-inline mb-0">
                                                <li className="list-inline-item">
                                                    <i className="ri-question-answer-line align-bottom"></i> {item.commentCount}
                                                </li>
                                                <li className="list-inline-item">
                                                    <i className="ri-attachment-2 align-bottom"></i> {item.documentCount}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="progress progress-sm bg-soft-success">
                                    <div className={`progress-bar ${props.titleClass}`} style={{width: "100%"}} aria-valuenow="55" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                        );
                    })}

                    {props.list && props.list.length === 0 &&
                    <div className="">
                        <div className="">
                            <div className="d-flex mb-2">
                                <h6 className="fs-15 mb-0 flex-grow-1 text-truncate task-title"><div className="text-body d-block">No {props.title} Tickets</div></h6>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </SimpleBar>

            <ConfirmModal message={"Are you sure you want to Assign the ISO Ticket?"} show={showAssignMeModal} onCloseClick={onCloseModalClick} onYesClick={onAssignMeTicket} />
            <ConfirmModal message={"Are you sure you want to Assign the ISO Ticket?"} show={showAssignModal} onCloseClick={onCloseModalClick} onYesClick={onAssignTicket} />
        </div>
    );
};

export default IsoDashboardList;